module.exports = __webpack_public_path__ + "static/media/xoleg_mild_left.acdc7c00.png";